import { Percomatic } from '@biggby-coffee/percomatic-typescript';

export const getCartFromTrans = (
	currentTrans: Percomatic.Serialized.Transaction
): Percomatic.Inputs.Transaction => ({
	id: currentTrans.id,
	items: currentTrans.items.map(item => ({
		id: item.id,
		itemId: item.item.id,
		modifiers: item.modifiers.map(mod => ({
			id: mod.id,
			modifierId: mod.modifier.id,
			quantity: mod.quantity
		}))
	}))
});
